import React from "react";
import { useSelector } from "react-redux";

import { RootState } from "../../../../store";
import { UserMode } from "../../../../interfaces/User";
import SalaryList from "../../../Payroll/Salary/SalaryList";

export default function UserSalaries(): React.ReactNode {
  const userContext = useSelector((state: RootState) => state.userContext);

  return (
    <SalaryList
      showEmployeeFilter={false}
      enableCreateNew={false}
      employeeIds={userContext.mode === UserMode.Employee ? [userContext.user.id] : []}
      serviceProviderIds={
        userContext.mode === UserMode.ServiceProvider ? [userContext.user.id] : []
      }
    />
  );
}
